export const EditControlCustomButtonsStyles = {
    Holder: {
        position: 'absolute',
        right: 0,
        // bottom: '56%',
        top: '170px',
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        zIndex: 400,
    } as const,
};
